export var linear = [0, 0, 1, 1];
export var ease = [0.25, 0.01, 0.25, 1];
export var easeIn = [0.42, 0, 1, 1];
export var easeOut = [0, 0, 0.58, 1];
export var easeInOut = [0.42, 0, 0.58, 1];
export var easeInQuad = [0.55, 0.085, 0.68, 0.53];
export var easeOutQuad = [0.25, 0.46, 0.45, 0.94];
export var easeInOutQuad = [0.455, 0.03, 0.515, 0.955];
export var easeInCubic = [0.55, 0.055, 0.675, 0.19];
export var easeOutCubic = [0.215, 0.61, 0.355, 1];
export var easeInOutCubic = [0.645, 0.045, 0.355, 1];
export var easeInBack = [0.6, -0.28, 0.735, 0.045];
export var easeOutBack = [0.175, 0.885, 0.32, 1.275];
export var easeInOutBack = [0.68, -0.55, 0.265, 1.55];